module.exports = __webpack_public_path__ + "static/media/study 201123.a437e994.png";